module.exports = __webpack_public_path__ + "static/media/COS_OCP_REPARTITION.e8fd2110.png";